module.exports = __webpack_public_path__ + "static/media/intro_bold_italic.2bc3cf2c.TTF";